[
  {
    "id": "12345678-2281-4b65-8899-1d2f36f251f0",
    "scanDate": "2025-10-20T12:00:00Z",
    "floor": 1
  },
  {
    "id": "ef654111-1234-4abc-9def-2a1b2c3d4e5f",
    "scanDate": "2025-07-01T12:00:00Z",
    "floor": 1
  }
]